<!-- achievemnet wrapper -->
<div #achievementwrapper class="achievement-wrapper">
    <div class="achievement-super">
        <div #achievementbody class="achievement-body" style="--auto-height: 64px">
            <p class="achievement-text">{{questionaryquestionbadgetitle}}</p>
            <p class="achievement-subtext">{{questionaryquestionbadgemessage}}</p>
        </div>
        <div class="achievement-title">
            <img [src]="'/images/svgs/' + questionaryquestionbadgecode + '.svg'"/>
        </div>
    </div>
</div>
<div #achievementbodyclone class="achievement-bodyclone">
    <p class="achievement-text">{{questionaryquestionbadgetitle}}</p>
    <p class="achievement-subtext">{{questionaryquestionbadgemessage}}</p>
</div>




